module.exports = __webpack_public_path__ + "img/slide-4-image@3x.099dcb0e.jpg";